"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _mobxReact = require("mobx-react");
var _mobx = require("mobx");
var _state = require("@seedlang/state");
var _utils = require("@seedlang/utils");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
var TreeNodeShowWrapper = function TreeNodeShowWrapper(Component) {
  var _class, _class2, _descriptor;
  return (0, _mobxReact.observer)(_class = (_class2 = /*#__PURE__*/function (_React$Component) {
    function _class2(props) {
      var _this;
      _classCallCheck(this, _class2);
      _this = _callSuper(this, _class2, [props]);
      _initializerDefineProperty(_this, "showEvent", _descriptor, _this);
      if (!_state.TreeUI.userTreeNodeStore.hasIndexData) {
        _state.TreeUI.userTreeNodeStore.getIndex();
      }
      (0, _mobx.autorun)(function () {
        var _this$treeNode;
        if (!_this.showEvent && (_this$treeNode = _this.treeNode) !== null && _this$treeNode !== void 0 && _this$treeNode.name) {
          var _this$treeNode2;
          _this.showEvent = true;
          _state.AppUI.createEvent('stories - view tree node', {
            name: (_this$treeNode2 = _this.treeNode) === null || _this$treeNode2 === void 0 ? void 0 : _this$treeNode2.name
          });
        }
      });
      return _this;
    }
    _inherits(_class2, _React$Component);
    return _createClass(_class2, [{
      key: "treeNode",
      get: function get() {
        var _this2 = this;
        if ((0, _utils.isPresent)(_state.TreeUI.storiesTree)) {
          return _state.TreeUI.storiesTree.treeNodes.find(function (item) {
            return item.id === _this2.treeNodeId;
          });
        }
      }
    }, {
      key: "userTreeNode",
      get: function get() {
        var _this3 = this;
        if (_state.TreeUI.userTreeNodeStore.hasIndexData) {
          return _state.TreeUI.userTreeNodeStore.indexData.find(function (item) {
            return item.treeNodeId === _this3.treeNodeId;
          });
        }
      }
    }, {
      key: "treeNodeId",
      get: function get() {
        if (this.props.treeNodeId) {
          return this.props.treeNodeId;
        } else if (this.props.params) {
          return this.props.params.treeNodeId;
        } else if (this.props.route) {
          var _this$props$route$par;
          return (_this$props$route$par = this.props.route.params) === null || _this$props$route$par === void 0 ? void 0 : _this$props$route$par.treeNodeId;
        }
      }
    }, {
      key: "showGrammar",
      get: function get() {
        return this.treeNode && (this.treeNode.hasGrammarDescription || (0, _utils.isPresent)(this.treeNode.grammarConcepts));
      }
    }, {
      key: "showVocab",
      get: function get() {
        var treeNode = this.treeNode;
        if (!treeNode || !treeNode.treeNodeDecks) return false;
        return treeNode.treeNodeDecks.some(function (treeNodeDeck) {
          var _treeNodeDeck$deck;
          return (0, _utils.isPresent)((_treeNodeDeck$deck = treeNodeDeck.deck) === null || _treeNodeDeck$deck === void 0 ? void 0 : _treeNodeDeck$deck.wordsList);
        });
      }
    }, {
      key: "tabs",
      get: function get() {
        var tabs = [{
          name: 'decks',
          label: 'Decks',
          "default": true
        }];
        if (this.showVocab) {
          tabs.push({
            name: 'vocab',
            label: 'Vocab'
          });
        }
        if (this.showGrammar) {
          tabs.push({
            name: 'grammar',
            label: 'Grammar'
          });
        }
        return tabs;
      }
    }, {
      key: "render",
      value: function render() {
        return /*#__PURE__*/_react["default"].createElement(Component, _extends({}, this.props, {
          treeNodeId: this.treeNodeId,
          treeNode: this.treeNode,
          userTreeNode: this.userTreeNode,
          tabs: this.tabs,
          showGrammar: this.showGrammar
        }));
      }
    }]);
  }(_react["default"].Component), _descriptor = _applyDecoratedDescriptor(_class2.prototype, "showEvent", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _applyDecoratedDescriptor(_class2.prototype, "treeNode", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "treeNode"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "userTreeNode", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "userTreeNode"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "treeNodeId", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "treeNodeId"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "showGrammar", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "showGrammar"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "showVocab", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "showVocab"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "tabs", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "tabs"), _class2.prototype), _class2)) || _class;
};
TreeNodeShowWrapper.displayName = 'TreeNodeShowWrapper';
var _default = exports["default"] = TreeNodeShowWrapper;